import { render, staticRenderFns } from "./SelectDataRep.vue?vue&type=template&id=372ffd46&"
import script from "./SelectDataRep.vue?vue&type=script&lang=js&"
export * from "./SelectDataRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports